<template>
    <div>
        <div v-if="category.background" class="category-image">
            <img :src="category.background.media_url" :alt="removeSpecialChars(category.meta.title)">
        </div>
        <div class="wrap">
            <div class="category-content">
                <div v-if="category.background && category.thumbnail_2" class="logo-brand">
                    <img :src="category.thumbnail_2.media_url" :alt="removeSpecialChars(category.meta.title)">
                </div>
                <div class="category-title-block">
                    <div class="category-title-row">
                        <h1 v-if="metaObject" class="category-title-name big">
                            {{ metaObject.h1 }}
                        </h1>
                        <h1 v-else class="category-title-name big">
                            {{ category.meta.title }}
                        </h1>
                        <div class="category-buttons">
                            <button type="button" class="btn-tr btn-mode" id="btn-grid-mode" @click="changeCardMode">
                                <img src="/img/front/icons/row-mode.svg" alt="" id="row-mode" v-show="cardMode == 'card-mode'">
                                <img src="/img/front/icons/card-mode.svg" alt="" id="card-mode" v-show="cardMode == 'grid-mode'">
                                <img src="/img/front/icons/grid-mode.svg" alt="" id="grid-mode" v-show="cardMode == 'row-mode'">
                            </button>
                            <button type="button" class="btn btn-filter filter-open" id="btn-filter">
                                <svg class="icon">
                                    <use xlink:href="/img/front/icons/svgmap.svg#filter" />
                                </svg>
                                <span class="text">
                                    {{ trans('product.filters') }}
                                </span>
                            </button>
                        </div>
                    </div>
                    
                    <filterProducts
                        :category="category"
                        :title="category.meta.title"
                        :min_price="min_price"
                        :max_price="max_price"
                        object_type="collection"
                        @change="filter"
                        @preloadFilterQuery = "setFilterQuery"
                    />
                    
                    <div class="category-title-container">
                        <ul class="category-title-slider">
                            <li v-for="(category, index) in child_categories" :key="index">
                                <a :href="category.slug_suffix" class="category-title-item">
                                    <span class="text">{{ category.meta.title }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="category-products" :class="{ 'disable-block': loading }" id="grid-category">
                    <div class="row">
                        <div v-for="item in products_pagged.data" :key="item.id" class="col col-md-6 col-lg-3" v-bind:class="cardWrapClass">
                            <div class="card" v-bind:class="cardClass">
                                <productItem :item="item" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- More button -->
                <div :class="{ 'disable-block': loading }" class="load_more">
                    <button v-if="!lastPage" class="assortment__load-more btn btn-load" type="button" @click="getMoreResults">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#reset"></use>
                    </svg>
                    {{ trans('layout.loadmore') }}
                    </button>
                </div>

                <!-- Pagination -->
                <pagination :class="{ 'disable-block': loading }" align="center" :data="products_pagged" @pagination-change-page="getPaginationResults" :limit="limit" />
            </div>
        </div>
    </div>
</template>

<script>
import helper from "./../mixins/helper";
import productList from "./../mixins/productList";
import cardMode from "./../mixins/cardMode";

export default {
    mixins: [
        helper,
        productList,
        cardMode
    ],
    computed: {
        axioDataMore: function () {
            return {
                collection_id: this.category.id,
                page: this.products_pagged.current_page + 1,
                filter: this.filter_query_checked_defaults
            }
        }
    },
    methods: {
        axioDataPagination(page) {
            return {
                collection_id: this.category.id,
                page: page,
                filter: this.filter_query_checked_defaults
            }
        }
    }
}
</script>
